import { PropertyCarouselDataDisplayProps } from './types';
import './styles.scss';
import { displayNDecimals } from 'utils/utils';

function PropertyCarouselDataDisplay(props: PropertyCarouselDataDisplayProps) {
  const { currencySymbol, baseDailyRate, city, name, state } = props;
  return (
    <div className="hotel-meta">
      <div className="property-slider-meta-inner">
        <span className="meta-location">
          {city}
          {!!state && `, ${state}`}
        </span>
        <h3 className="meta-name">{name}</h3>
      </div>
      <div className="property-slider-meta-price">
        <p className="meta-price-text">
          from <strong className="meta-price-value">{currencySymbol}{!!baseDailyRate ? displayNDecimals(baseDailyRate) : '--'}</strong>
        </p>
      </div>
    </div>
  );
}
export default PropertyCarouselDataDisplay;
